import Table from '../Table/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/pro-regular-svg-icons'
import { faMoneyCheckEdit  } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from '../architecture/frontend/index'
import _ from 'lodash'
import loadingSVG from '../../media/loading.svg'

import {useState} from 'react'

const columnLayout = [
  {
    field: 'checkbox',
    header: '',
    type: 'checkbox',
    width: '40px',
    fieldStyle: 'justify-center'
  },
  {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'shipmentId',
    header: 'Shipment',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'claimId',
    header: 'Claim Id',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'claimedDate',
    header: 'Claim Date',
    type: 'date',
    style: 'tc',
    fieldStyle: 'tc justify-center'
  },
  {
    field: 'refereeSentDate',
    header: 'Ref Date',
    type: 'date',
    style: 'tc',
    fieldStyle: 'tc justify-center'
  },
  {
    field: 'claimMoisturePercent',
    header: 'M',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc'
  },
  {
    field: 'claimProtein12Percent',
    header: 'P',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc'
  },
  {
    field: 'claimFiber12Percent',
    header: 'F',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc'
  },
  // {
  //   field: 'refereeDate',
  //   header: 'Ref Date',
  //   type: 'date',
  //   groupHeader: 'Referee 12%',
  //   style: 'bg-light-green tc',
  //   fieldStyle: 'tc justify-center'
  // },
  {
    field: 'refereeMoisturePercent',
    header: 'M',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tc'
  },
  {
    field: 'refereeProtein12Percent',
    header: 'P',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tc'
  },
  {
    field: 'refereeFiber12Percent',
    header: 'F',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tc'
  },
  {
    field: 'settlementMoistureDollars',
    header: 'M',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    preText: '$'
  },
  {
    field: 'settlementProteinDollars',
    header: 'P',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    preText: '$'
  },
  {
    field: 'settlementFiberDollars',
    header: 'F',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    preText: '$'
  },
  {
    field: 'refereeFee',
    header: 'Ref Fee',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    preText: '$'
  },
  {
    field: 'settlementAdjustmentDollars',
    header: 'Adjust',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    preText: '$'
  },
  {
    field: 'settlementTotalDollars',
    header: 'Net',
    type: 'text',
    groupHeader: 'Settlement Dollars',
    style: 'tc',
    fieldStyle: 'ph2 tr',
    childClass: 'fw7',
    preText: '$'
  },
]

const TableSet = (props) => {
  const customerCode = props._customer?.code
  const customerName = props._customer?.name
  const tableName = 'tableName-' + customerCode
  const data = _.filter(props.shipments?.rawData, shipment => shipment.customer?.code === customerCode )

  const [checkNumber, setCheckNumber] = useState(null)
  const disabledClass = (checkNumber && checkNumber!== '') ? ' ' : ' o-50 '
  const disabledStyle = (checkNumber && checkNumber!== '') ? {} : {pointerEvents: 'none'}
  const checked = props?.table?.[tableName]?.checked ?? []
  const total = _.filter(data, shipment => _.findIndex(checked, check => check === shipment.id) !== -1).reduce((acc,next) => acc + parseFloat(next.settlementTotalDollars), 0)
  return (
    <div className='mt3 pa2 w-100 ba b--moon-gray br3' style={{background: '#f5f3f5'}}>
      <div className='ph3 pt1  w-100 flex justify-between items-end'>
        <div className='pl1 pt1 f6 fw5 dark-gray'>
          <div className='flex'>
            <div>
              <div className='tr'>Customer: </div>
              <div className='tr pt1'>Check Number: </div>
            </div>
            <div className='pl3'>
              <div className=''>{customerCode} - {customerName}</div>
              <input 
                className='w-100 pa2 br2 bg-white f7 ba b--moon-gray ' 
                style={{ outline: 'none', borderStyle: 'solid' }} 
                type="text" 
                // name={updateType}
                placeholder='#'
                onChange={e=> setCheckNumber(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className='flex'>
          <div className={'mh1 mb2 pv2 ph3 br2 white f6 flex pointer ' + disabledClass} style={{background: '#6ba686', ...disabledStyle}}
            onClick={e => Dispatch.nextAction('__.Modal.open', {
                type: 'email', 
                details: {
                  title: "Send Claim Settlement Details",
                  description: "Use the following form to send a copy of the Claim Settlement Details Report as an email attachment",
                  onClick: (e, args) => Dispatch.nextAction('shipments.sendSettlement', { tableName: tableName, checkNumber, sendEmail: true, toAddress: args.toAddress, message: args.message}),
                  request: 'sendSettlement',
                  dataType: 'sendSettlement',
                  defaultEmail: props._customer?.email,
                  defaultMessage: 'Please see the attached pdf for claim settlement information:',
                  checkNumber,
                  emailCC: props.user.email
                }
              })}
            > <FontAwesomeIcon className='pr2 f6 white' icon={faEdit} /> Email </div>
          
          {/* <div className={'mh1 mb2 pv2 ph3 br2 white f6 flex pointer ' + disabledClass} 
            style={{background: '#6ba686', ...disabledStyle}}
            onClick={e => Dispatch.nextAction('shipments.downloadSettlement', { tableName, checkNumber })}
            > 
              <FontAwesomeIcon className='pr2 f6 white' icon={faPaperclip} /> Download 
          </div> */}
        </div>
      </div>
      <div className='pt3 w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={tableName} _shipments={data} _columnLayout={columnLayout} {...props}/>
      </div>
      <div className='pt1 w-100 flex justify-between'>
        <div></div>
        <div className='pr2 f6 fw7'>Total: {total.toFixed(2)}</div>
      </div>
    </div>
  )
}

const AllSamples = (props) => {
  const unique = !props.shipments?.loading ? _.uniqBy(props.shipments?.rawData, shipment => { return shipment.customer?.id }) : 'loading'
  return (
    <div className='w-100 ph3 overflow-y-auto' style={{maxHeight: props.ui?.window?.height - props.ui?.window?.header - 5}}>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' style={{position:'sticky', top:0, zIndex:5000}} >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faMoneyCheckEdit} style={{top:-3}} />
          <div className='pl2 fw7 f6 white'>Claims Requiring Payment </div>
          <div className='h2'></div>
        </div>
        <div className='flex'>
        </div>
      </div>
      {unique === 'loading' ? 
        <div className='h5 w-100 flex justify-center'>
          <img className='w4' src={loadingSVG} alt='loading'></img>
        </div>
        :
        unique.length > 0 ? unique.map(uni => {
          return (
            <TableSet key={uni.customer?.id} _customer={uni.customer} {...props} />
          )
        })
        :
        <div className='w-100 pt4 flex justify-center'>
          <div class='f5'>No Data To Display</div>
        </div>
      }
    </div>
  )
}

export default AllSamples